"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Facts_1 = require("../../facts/Facts");
var RugbyUnionSpecificFact;
(function (RugbyUnionSpecificFact) {
    RugbyUnionSpecificFact["TRY"] = "TRY";
    RugbyUnionSpecificFact["TRY_ASSIST"] = "TRY_ASSIST";
    RugbyUnionSpecificFact["PENALTY_TRY"] = "PENALTY_TRY";
    RugbyUnionSpecificFact["CONVERSION"] = "CONVERSION";
    RugbyUnionSpecificFact["CONVERSION_MISSED"] = "CONVERSION_MISSED";
    RugbyUnionSpecificFact["PENALTY_GOAL"] = "PENALTY_GOAL";
    RugbyUnionSpecificFact["PENALTY_GOAL_MISSED"] = "PENALTY_GOAL_MISSED";
    RugbyUnionSpecificFact["DROP_GOAL"] = "DROP_GOAL";
    RugbyUnionSpecificFact["DROP_GOAL_MISSED"] = "DROP_GOAL_MISSED";
    RugbyUnionSpecificFact["KICKING_COMP_GOALS"] = "KICKING_COMP_GOALS";
    RugbyUnionSpecificFact["KICKING_COMP_GOALS_MISSED"] = "KICKING_COMP_GOALS_MISSED";
    RugbyUnionSpecificFact["YELLOW_CARD"] = "YELLOW_CARD";
    RugbyUnionSpecificFact["RED_CARD"] = "RED_CARD";
    RugbyUnionSpecificFact["LINEOUT"] = "LINEOUT";
    RugbyUnionSpecificFact["LINEOUT_CONCEDED"] = "LINEOUT_CONCEDED";
    RugbyUnionSpecificFact["SCRUM"] = "SCRUM";
    RugbyUnionSpecificFact["SCRUM_CONCEDED"] = "SCRUM_CONCEDED";
    RugbyUnionSpecificFact["CLEAN_BREAK"] = "CLEAN_BREAK";
    RugbyUnionSpecificFact["DEFENDER_BEATEN"] = "DEFENDER_BEATEN";
    RugbyUnionSpecificFact["PENALTY_CONCEDED"] = "PENALTY_CONCEDED";
    RugbyUnionSpecificFact["TURNOVER_CONCEDED"] = "TURNOVER_CONCEDED";
    RugbyUnionSpecificFact["RUCK"] = "RUCK";
    RugbyUnionSpecificFact["RUCK_CONCEDED"] = "RUCK_CONCEDED";
    RugbyUnionSpecificFact["RESTART"] = "RESTART";
    RugbyUnionSpecificFact["FREE_KICK"] = "FREE_KICK";
    RugbyUnionSpecificFact["KICK"] = "KICK";
})(RugbyUnionSpecificFact = exports.RugbyUnionSpecificFact || (exports.RugbyUnionSpecificFact = {}));
exports.rugbyUnionPlayerFacts = [
    RugbyUnionSpecificFact.TRY,
    RugbyUnionSpecificFact.TRY_ASSIST,
    RugbyUnionSpecificFact.PENALTY_TRY,
    RugbyUnionSpecificFact.CONVERSION,
    RugbyUnionSpecificFact.CONVERSION_MISSED,
    RugbyUnionSpecificFact.PENALTY_GOAL,
    RugbyUnionSpecificFact.PENALTY_GOAL_MISSED,
    RugbyUnionSpecificFact.DROP_GOAL,
    RugbyUnionSpecificFact.DROP_GOAL_MISSED,
    RugbyUnionSpecificFact.KICKING_COMP_GOALS,
    RugbyUnionSpecificFact.KICKING_COMP_GOALS_MISSED,
    RugbyUnionSpecificFact.YELLOW_CARD,
    RugbyUnionSpecificFact.RED_CARD,
    RugbyUnionSpecificFact.CLEAN_BREAK,
    RugbyUnionSpecificFact.DEFENDER_BEATEN,
    RugbyUnionSpecificFact.FREE_KICK,
    RugbyUnionSpecificFact.KICK,
    Facts_1.SubstitutionFact.SUBSTITUTION
];
//# sourceMappingURL=Facts.js.map